import { SEARCH_PAGE_VIEW_LAYOUT } from "../../util/types";

export const searchPageLayoutSwitcher = (searchPageViewLayout, intl) => {
  switch (searchPageViewLayout) {
    case SEARCH_PAGE_VIEW_LAYOUT.MAP:
      return {
        label: intl.formatMessage({ id: 'MainPanelHeader.viewListOnly' }),
        to: 'GridViewPage',
      };
    case SEARCH_PAGE_VIEW_LAYOUT.GRID:
      return {
        label: intl.formatMessage({ id: 'MainPanelHeader.viewMapAndList' }),
        to: 'MapViewPage',
      };
    default:
      return { label: null, to: 'SearchPage' };
  }
};